module.exports = __webpack_public_path__ + "static/media/face.972a1aa3.gif";